var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { when } from 'mobx';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { RuntimeScheduleNextState } from './RuntimeScheduleNextState';
import { RuntimeScheduleNextIdle } from './RuntimeScheduleNextIdle';
import { RuntimeScheduleNextAnimationFrame } from './RuntimeScheduleNextAnimationFrame';
import { bound } from '../../../../utils/decorators/basic';
export class RuntimeScheduler {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    get nextState() {
        return new RuntimeScheduleNextState(this.runtime);
    }
    get nextIdle() {
        return new RuntimeScheduleNextIdle(this.runtime);
    }
    get nextAnimationFrame() {
        return new RuntimeScheduleNextAnimationFrame(this.runtime);
    }
    async addToNextStateChange(action, options = {}) {
        return await this.nextState.addToNext(action, options);
    }
    async addToNextIdleStateChange(action, options = {}) {
        return await this.nextIdle.addToNext(action, options);
    }
    async scheduleIdleBackgroundTask(action, options = {}) {
        if (this.parent.isBrowserRuntime) {
            await when(() => this.parent.solidBrowserRuntime.app.appBoot.isInteractiveStable);
        }
        return await this.nextIdle.addToNext(() => this.addToNextIdleStateChange(action), options);
    }
    async scheduleForAnimationFrame(action, options = {}) {
        return await this.nextAnimationFrame.addToNext(action, options);
    }
}
__decorate([
    memoize
], RuntimeScheduler.prototype, "nextState", null);
__decorate([
    memoize
], RuntimeScheduler.prototype, "nextIdle", null);
__decorate([
    memoize
], RuntimeScheduler.prototype, "nextAnimationFrame", null);
__decorate([
    bound
], RuntimeScheduler.prototype, "addToNextStateChange", null);
__decorate([
    bound
], RuntimeScheduler.prototype, "addToNextIdleStateChange", null);
__decorate([
    bound
], RuntimeScheduler.prototype, "scheduleIdleBackgroundTask", null);
__decorate([
    bound
], RuntimeScheduler.prototype, "scheduleForAnimationFrame", null);
